import { render } from "./PaginationControls.vue?vue&type=template&id=0a2161bf&scoped=true&ts=true"
import script from "./PaginationControls.vue?vue&type=script&lang=ts"
export * from "./PaginationControls.vue?vue&type=script&lang=ts"

import "./PaginationControls.vue?vue&type=style&index=0&id=0a2161bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2161bf"]])

export default __exports__